import React from "react";
import { FormattedMessage } from "react-intl";
import { Button, Row } from "@masterteam/mt-design-react";

import Modal from "../../Modal";
import History from "./History";
import EmptyData from "../../EmptyData";

import { ReactComponent as CloseIcon } from "../../../assets/images/close.svg";

import "./style.scss";

const WorkflowModal = ({ data, onClose }) => {
  return (
    <Modal isOpen={true}>
      <div className="workflow-modal">
        <Row
          justify="between"
          align="center"
          className="workflow-modal__header"
        >
          <FormattedMessage id="my-task.workflow" />
          <Button
            fill="none"
            variant="dark"
            shape="square"
            onClick={onClose}
            Icon={CloseIcon}
          />
        </Row>
        <div className="workflow-modal__content">
          {data ? (
            <History data={data} />
          ) : (
            <EmptyData
              title={<FormattedMessage id="task-center.should-update" />}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default WorkflowModal;
